import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

interface BlockedDate {
  id: number;
  date: string;
  createdBy: number;
  createdAt: string;
}

interface UseBlockedDatesParams {
  from?: Date;
  to?: Date;
}

export function useBlockedDates(params?: UseBlockedDatesParams) {
  return useQuery<BlockedDate[]>({
    queryKey: ["blocked-dates", params?.from, params?.to],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      
      if (params?.from) {
        searchParams.append("from", format(params.from, "yyyy-MM-dd"));
      }
      if (params?.to) {
        searchParams.append("to", format(params.to, "yyyy-MM-dd"));
      }

      const url = `/api/admin/blocked-dates${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
      const res = await fetch(url);
      
      if (!res.ok) {
        throw new Error("Failed to fetch blocked dates");
      }
      
      return res.json();
    },
  });
}